import { FormattedMessage } from 'react-intl';

export const navigationMessages = {
  'navigation.menu.label': (
    <FormattedMessage id="navigation.menu.label" defaultMessage="Menu" />
  ),
  'navigation.menuEntry.dashboard.label': (
    <FormattedMessage
      id="navigation.menuEntry.dashboard.label"
      defaultMessage="Dashboard"
    />
  ),

  'navigation.menuEntry.animals.label': (
    <FormattedMessage
      id="navigation.menuEntry.animals.label"
      defaultMessage="Animals"
    />
  ),
  'navigation.menuEntry.imports.label': (
    <FormattedMessage
      id="navigation.menuEntry.imports.label"
      defaultMessage="Imports"
    />
  ),
  'navigation.menuEntry.solrSync.label': (
    <FormattedMessage
      id="navigation.menuEntry.solrSync.label"
      defaultMessage="Solr sync"
    />
  ),
  'navigation.menuEntry.audit.label': (
    <FormattedMessage
      id="navigation.menuEntry.audit.label"
      defaultMessage="Audit Log"
    />
  ),
  'navigation.menuEntry.memberships.label': (
    <FormattedMessage
      id="navigation.menuEntry.memberships.label"
      defaultMessage="Memberships"
    />
  ),
  'navigation.menuEntry.members.label': (
    <FormattedMessage
      id="navigation.menuEntry.members.label"
      defaultMessage="Members"
    />
  ),
  'navigation.menuEntry.breedSocieties.label': (
    <FormattedMessage
      id="navigation.menuEntry.breedSocieties.label"
      defaultMessage="Breed societies"
    />
  ),
  'navigation.groups.label': (
    <FormattedMessage id="navigation.groups.label" defaultMessage="Groups" />
  ),
  'navigation.menuEntry.configurations.label': (
    <FormattedMessage
      id="navigation.menuEntry.configurations.label"
      defaultMessage="Configuration"
    />
  ),
  'navigation.subMenu.configurations.members.label': (
    <FormattedMessage
      id="navigation.subMenu.configurations.members.label"
      defaultMessage="Members"
    />
  ),
  'navigation.subMenu.configurations.certificateTemplates.label': (
    <FormattedMessage
      id="navigation.subMenu.configurations.certificateTemplates.label"
      defaultMessage="Certificates"
    />
  ),
  'navigation.subMenu.configurations.rules.label': (
    <FormattedMessage
      id="navigation.subMenu.configurations.rules.label"
      defaultMessage="Rules"
    />
  ),
  'navigation.subMenu.configurations.formsManager.label': (
    <FormattedMessage
      id="navigation.subMenu.configurations.formsManager.label"
      defaultMessage="Forms"
    />
  ),
  'navigation.subMenu.configurations.logo.label': (
    <FormattedMessage
      id="navigation.subMenu.configurations.logo.label"
      defaultMessage="Logo"
    />
  ),
  'navigation.subMenu.configurations.import.label': (
    <FormattedMessage
      id="navigation.subMenu.configurations.import.label"
      defaultMessage="Import data"
    />
  ),
  'navigation.subMenu.configurations.animals.label': (
    <FormattedMessage
      id="navigation.subMenu.configurations.animals.label"
      defaultMessage="Animals"
    />
  ),
  'navigation.menuEntry.form-builder.label': (
    <FormattedMessage
      id="navigation.menuEntry.form-builder.label"
      defaultMessage="Forms"
    />
  ),
  'navigation.menuEntry.form-builder.fields-config.label': (
    <FormattedMessage
      id="navigation.menuEntry.form-builder.fields-config.label"
      defaultMessage="Fields"
    />
  ),
  'navigation.menuEntry.tests.label': (
    <FormattedMessage
      id="navigation.menuEntry.tests.label"
      defaultMessage="Tests"
    />
  ),
};

export const footerMessages = {
  'footer.copyright.label': (
    <FormattedMessage
      id="footer.copyright.label"
      defaultMessage="2024 BreedLOGIC"
    />
  ),
  'footer.terms.label': (
    <FormattedMessage id="footer.terms.label" defaultMessage="Terms" />
  ),
  'footer.userAgreement.label': (
    <FormattedMessage
      id="footer.userAgreement.label"
      defaultMessage="User agreement"
    />
  ),
  'footer.privacy.label': (
    <FormattedMessage id="footer.privacy.label" defaultMessage="Privacy" />
  ),
  'footer.support.label': (
    <FormattedMessage
      id="footer.support.label"
      defaultMessage="Support & resources"
    />
  ),
};
